import { z } from "zod";
import { IsoDateTime } from "./common.ts";

export const MbApiLogEntrySchema = z.object({
  ts: IsoDateTime,
  seq: z.number().int().nonnegative(),
  day: z.string().min(1),
  day_count: z.number().int().nonnegative(),
  method: z.string().min(1),
  path: z.string().min(1),
  status: z.number().int(),
  ms: z.number().int().nonnegative(),
  ok: z.boolean(),
  retry_after: z.number().nullable(),
  reason: z.string().nullable(),
  label: z.string().nullable(),
  retry: z.number().int().nonnegative(),
});

export type MbApiLogEntry = z.infer<typeof MbApiLogEntrySchema>;

export const MbApiDayStatsSchema = z.object({
  day: z.string().min(1),
  calls: z.number().int().nonnegative(),
  by_status: z.record(z.string(), z.number().int().nonnegative()),
  last_seq: z.number().int().nonnegative(),
});

export type MbApiDayStats = z.infer<typeof MbApiDayStatsSchema>;

export const MbApiLogTailSchema = z.object({
  entries: z.array(MbApiLogEntrySchema),
  stats: MbApiDayStatsSchema,
  log_path: z.string().min(1),
});

export type MbApiLogTail = z.infer<typeof MbApiLogTailSchema>;
